import { RichContent } from '@corratech/pylot-rich-content'
import React from 'react'
import { GridPage } from './GridPage'
import chunk from 'lodash/chunk'
import s from './Plpgrid.module.scss'
import cn from 'classnames'

type MarketingTile = {
    start: {
        col: number
        row: number
    }
    size: {
        height: number
        width: number
    }
    content: string
    class: string
}

type ImageDisruptorTitle = {
    recordId: string
    blockPosition: number
    blockId: string
}

type PlpGridPropTypes<P> = {
    products: P[]
    ProductTile: React.ComponentType<P>
    LoadingTile: React.ComponentType
    marketingTiles?: MarketingTile[]
    imageDisruptorData?: ImageDisruptorTitle[]
    pageSize?: number
    isLoading?: boolean
}

export const PLPGrid = ({
    products,
    ProductTile,
    LoadingTile,
    marketingTiles = [],
    imageDisruptorData = [],
    pageSize,
    isLoading = false
}: PlpGridPropTypes<any>): JSX.Element => {
    const cols = 4

    const processImageDisruptorData = imageDisruptorData.map((item) => ({
        ...item,
        startIdx: Number(item.blockPosition)
    }))

    const processedMarketing = marketingTiles.map((item) => ({
        ...item,
        startIdx: item.start.row * cols + item.start.col
    }))

    const getMarketing = (idx: number) => {
        const filteredMarketing = processedMarketing.filter(
            (item) => item.startIdx === idx
        )
        if (filteredMarketing.length) {
            return (
                <div
                    className={cn(
                        filteredMarketing[0].class,
                        'hidden md:block'
                    )}
                    style={{
                        gridColumn: `${filteredMarketing[0].start.col} / span ${filteredMarketing[0].size.width}`,
                        gridRow: `${Math.floor(idx / cols)} / span ${
                            filteredMarketing[0].size.height
                        }`
                    }}
                >
                    <RichContent html={filteredMarketing[0].content} />
                </div>
            )
        } else return null
    }

    if (isLoading)
        return (
            <div className={s.Plpgrid}>
                <GridPage
                    startingIndex={0}
                    items={[{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]}
                    ProductTile={LoadingTile}
                    getMarketing={getMarketing}
                    processedImageDisruptorData={processImageDisruptorData}
                />
            </div>
        )
    else
        return (
            <div className={s.Plpgrid}>
                {chunk(products, pageSize ?? products.length).map(
                    (items, key) => (
                        <GridPage
                            key={key}
                            startingIndex={pageSize ? key * pageSize : 0}
                            items={items}
                            ProductTile={ProductTile}
                            getMarketing={getMarketing}
                            processedImageDisruptorData={
                                processImageDisruptorData
                            }
                        />
                    )
                )}
            </div>
        )
}
